import React, { useEffect, useState } from 'react'

import { useFreeSpinsBonusesStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import {
    BonusSystemState,
    Bonus,
    BonusesPlayNowMessage,
    GameUIMessageType,
    BonusesPlayLaterMessage,
    BonusStates,
} from 'game-ui-types'

interface FSMainButtonsProps {
    bonus?: Bonus
}

const FSMainButtons: React.FC<FSMainButtonsProps> = ({ bonus }: FSMainButtonsProps) => {
    const bonusSystemState = useFreeSpinsBonusesStore((state) => state.bonusSystemState)
    const setBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const bonuses = useFreeSpinsBonusesStore((state) => state.bonuses)

    const { t } = useTranslation()

    const [primaryButtonText, setPrimaryButtonText] = useState('')
    const [secondaryButtonText, setSecondaryButtonText] = useState('')

    const isInSingleBonusState = bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL
    const isInMultipleBonusesState = bonusSystemState === BonusSystemState.MULTIPLE_BONUSES_INITIAL

    useEffect(() => {
        switch (bonusSystemState) {
            case BonusSystemState.SINGLE_BONUS_INITIAL: {
                setPrimaryButtonText(t('gameui.playNow'))
                setSecondaryButtonText(t('gameui.playLater'))
                break
            }
            case BonusSystemState.MULTIPLE_BONUSES_INITIAL: {
                setPrimaryButtonText(t('gameui.playAllNow'))
                setSecondaryButtonText(t('gameui.playAllLater'))
                break
            }
        }
    }, [bonusSystemState])

    const playNowHandler = () => {
        const payload = {
            bonusIds: [],
        }

        if (bonuses.length > 1) {
            ;(payload.bonusIds as string[]) = bonuses.filter((b) => b.state === BonusStates.AWARDED).map((b) => b.id)
        } else {
            ;(payload.bonusIds as string[]) = bonuses.map((b) => b.id)
        }

        const message: BonusesPlayNowMessage = {
            type: GameUIMessageType.BONUSES_PLAY_NOW,
            payload,
        }

        if (isInSingleBonusState) {
            if (!bonus) {
                return
            }

            window.postMessage(message)
            setBonusSystemState(BonusSystemState.IN_PLAY)
        } else if (isInMultipleBonusesState) {
            window.postMessage(message)
            setBonusSystemState(BonusSystemState.IN_PLAY)
        }
    }

    const playLaterHandler = () => {
        if (isInSingleBonusState && !bonus) {
            return
        }

        if (isInSingleBonusState || isInMultipleBonusesState) {
            const message: BonusesPlayLaterMessage = {
                type: GameUIMessageType.BONUSES_PLAY_LATER,
                payload: { bonusIds: bonuses.map((b) => b.id) },
            }

            window.postMessage(message)
            setBonusSystemState(BonusSystemState.INACTIVE)
        }
    }

    return (
        <>
            <div className="flex justify-between gap-[20px] w-full px-[77px] pt-[24px] pb-[24px]">
                <BSModalButton
                    id={secondaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                    text={secondaryButtonText}
                    isPrimary={false}
                    onClick={playLaterHandler}
                />
                <BSModalButton
                    id={primaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                    text={primaryButtonText}
                    onClick={playNowHandler}
                />
            </div>
        </>
    )
}

export default FSMainButtons
